import React from "react";
import AttributeField from "./AttributeField";
import {
  ASSET_SELECT_TYPES,
  FORM_TYPES,
  updateVariableAttr,
} from "../../../common/CertificateOnboarding/utils/variables";

function AssetVariableEditor({ variableKey, attrs, setVariableConfig, t }) {
  const onAttrChange = (attrKey) => (value) => {
    updateVariableAttr(setVariableConfig, variableKey, attrKey, value);
  };

  const typeOptions = ASSET_SELECT_TYPES.map((val) => ({
    value: val,
    label: t(`certificateOnboarding:data_type_${val}`),
  }));

  const rawDataType = attrs["data-type"] ?? "photo";
  const fieldTypeValue = ASSET_SELECT_TYPES.includes(rawDataType)
    ? rawDataType
    : "photo";

  const formTypeOptions = FORM_TYPES.map((val) => ({
    value: val,
    label: t(`certificateOnboarding:form_type_${val}`),
  }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <AttributeField
        id={`${variableKey}-key`}
        label={t("certificateOnboarding:attr_data_key")}
        value={attrs["data-key"]}
        onChange={onAttrChange("data-key")}
      />

      <AttributeField
        id={`${variableKey}-label`}
        label={t("certificateOnboarding:attr_data_label")}
        value={attrs["data-label"]}
        onChange={onAttrChange("data-label")}
      />

      <AttributeField
        id={`${variableKey}-name`}
        label={t("certificateOnboarding:attr_data_name")}
        value={attrs["data-name"]}
        onChange={onAttrChange("data-name")}
      />

      <AttributeField
        id={`${variableKey}-max-size`}
        label={t("certificateOnboarding:attr_max_size")}
        value={attrs["max-size"]}
        onChange={onAttrChange("max-size")}
        placeholder="2500kb"
      />

      <AttributeField
        id={`${variableKey}-type`}
        label={t("certificateOnboarding:attr_data_type")}
        type="select"
        value={fieldTypeValue}
        onChange={onAttrChange("data-type")}
        options={typeOptions}
      />

      <AttributeField
        id={`${variableKey}-form-type`}
        label={t("certificateOnboarding:attr_data_form_type")}
        type="select"
        value={attrs["data-form-type"] ?? "template"}
        onChange={onAttrChange("data-form-type")}
        options={formTypeOptions}
      />

      <div className="md:col-span-2 flex items-center">
        <AttributeField
          id={`${variableKey}-required`}
          label={t("certificateOnboarding:attr_data_required")}
          type="toggle"
          value={attrs["data-required"]}
          onChange={onAttrChange("data-required")}
        />
      </div>
    </div>
  );
}

export default AssetVariableEditor;
